import { Button } from '@chakra-ui/react';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from '@/components/ui/dialog';
import type { ProgramDiscountCodeFormData } from './ProgramDiscountCodeForm';
import ProgramDiscountCodeForm from './ProgramDiscountCodeForm';

interface ProgramDiscountCodeModalProps {
  programId: string;
  isOpen: boolean;
  onClose: () => void;
  defaultValues?: Partial<ProgramDiscountCodeFormData>;
}

const ProgramDiscountCodeModal: React.FC<ProgramDiscountCodeModalProps> = ({
  programId,
  isOpen,
  onClose,
  defaultValues,
}) => {
  const { t } = useTranslation();
  const formRef = useRef<{ submit: () => void } | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };

  return (
    <DialogRoot open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('programs.modals.editDiscountCode.title')}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <ProgramDiscountCodeForm
            ref={formRef}
            programId={programId}
            defaultValues={defaultValues}
            onSubmitting={setIsSubmitting}
            onSuccess={onClose}
          />
        </DialogBody>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button onClick={handleSubmit} loading={isSubmitting} disabled={isSubmitting}>
            {t('common.save')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};

export default ProgramDiscountCodeModal;
